export default __webpack_public_path__ + "static/media/Welcome-Tohoku-University.a21d7e8c.svg";